import { render, staticRenderFns } from "./MypageTicketPastPage.vue?vue&type=template&id=794a0806"
import script from "./MypageTicketPastPage.vue?vue&type=script&lang=ts"
export * from "./MypageTicketPastPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports